import { ChangeEvent, useState } from "react";
import { FormGroup, Label, Input } from "reactstrap";
import { Col } from "reactstrap";

const TextField = ({
  input,
  label,
  meta: { touched, error, warning },
  type,
  disabled,
  isRequired,
  maxlength,
  textBlur,
  autoComplete,
  handleChange,
  min,
  placeholder,
  optional,
  className,
  isPrimary,
}: any) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <FormGroup row className={className ? `${className}` : "mb-0"}>
      <Label>
        {label}
        {isRequired && <span className="input-required">*</span>}
        {optional && <span className="optional">(optional)</span>}
      </Label>
      <Col sm={12} className="mr-2">
        <Input
          maxlength={maxlength}
          type={type}
          min={min}
          {...input}
          disabled={disabled}
          autoComplete={autoComplete}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            // event.target.value=event.target.value.trimStart();
            if (handleChange) handleChange(event);
            input.onChange(event);
          }}
          onBlur={(event: any) => {
            if (textBlur) textBlur(event);
            input.onBlur(event);
          }}
          placeholder={placeholder}
          className={className}
        />
        <h6 className="danger">
          {((touched && error) || (isPrimary && error)) && <span className="errorValidation">{error}</span>}
          {warning && <span className="errorValidation">{warning}</span>}
        </h6>
      </Col>
    </FormGroup>
  );
};

export default TextField;
